<div class="search-wrapper">
  <div class="search-bar-container">
    <!-- Main Search Input -->
    <div class="search-container">
      <input type="search" class="search-input" placeholder="Search..." [(ngModel)]="searchInput"
        (input)="onSearchInputChange()" (click)="$event.stopPropagation()" />
        <mat-icon class="search-icon">search</mat-icon>
      </div>
      <!-- <div *ngIf="isSearching" class="searching-indicator">
      Searching...
    </div> -->

    <!-- <div *ngIf="!isSearching && searchResults?.length">
    <div class="search-results">
      <div *ngFor="let search of searchResults; let i = index">
        <div
          class="search-result-item"
          (mouseover)="hoverActive = true; itemIndex = i; itemKey = search.item"
          (mouseout)="hoverActive = false; itemIndex = -1; itemKey = ''"
            [ngStyle]="
              hoverActive &&
              i === itemIndex &&
              itemKey == search.item && { 'background-color': 'rgb(221, 220, 231)' }
            "
          >
          <mat-icon class="mr-2">search</mat-icon>
          <a [routerLink]="['/search', { key: search.item }]">
            {{ search.item }}
          </a>
          <span *ngIf="search.module" class="module"> in {{ search.module }} </span>
        </div>
      </div>
    </div>
  </div> -->

  <!-- <div *ngIf="!isSearching && searchResults?.length === 0 && searchInput.length >= 3" class="no-results-message">
  No results found.
</div> -->

<!-- <div *ngIf="!isSearching && searchResults?.length === 0 && searchInput.length < 3 && recentSearches?.length > 0">
<div class="recent-searches">
  <div class="heading">RECENT SEARCHES</div>
  <div *ngFor="let search of recentSearches; let i = index" class="recent-search-item">
    <mat-icon class="mr-2">search</mat-icon>{{ search.item }}
    <span *ngIf="search.module" class="module"> in {{ search.module }} </span>
  </div>
</div>

</div> -->


<!-- Search Overlay Modal -->
@if (showOverlay) {
  <div class="search-overlay" (click)="closeSearch()">
    <div class="search-modal" (click)="$event.stopPropagation()">
      <!-- Search Header -->
      <!-- <div class="search-header"> -->
      <!-- <mat-icon class="search-icon">search</mat-icon> -->
      <!-- <input
      #searchInputModal
      type="search"
      class="search-input-modal"
      placeholder="Search..."
      [(ngModel)]="searchInput"
      (input)="onSearchInputChange()"
      autofocus
      />
      <button class="filter-button" [matMenuTriggerFor]="filterMenu">
        <mat-icon>tune</mat-icon>
      </button> -->
      <!-- <button class="close-button" (click)="closeSearch()">
      <mat-icon>close</mat-icon>
    </button> -->
  <!-- </div> -->
  <!-- Active Filters -->
  @if (searchInput) {
    <div class="active-filters">
      @if (searchInput.length >= 3) {
        <div class="filter-chip">
          <span class="chip-label">Searching for "<span [innerHTML]="highlightSearchText(searchInput, searchInput)"></span>"</span>
          <span class="results-count">{{ searchResults.length }} results</span>
        </div>
      }
    </div>
  }
  <!-- Search Content -->
  <div class="search-content-wrapper">
    <div class="search-content">
      <!-- Loading State -->
      @if (isSearching) {
        <div class="loading-state">
          <mat-spinner diameter="24"></mat-spinner>
          <span>Searching...</span>
        </div>
      }
      <!-- Search Results -->
      @if (!isSearching && searchInput.length >= 3) {
        <div class="results-section">
          <!--<div class="results-header">
          <span class="results-title">Search Results</span>
          <span class="results-count">{{ searchResults.length }} results</span>
        </div>-->
        <div class="results-list">
          @for (search of searchResults; track search) {
            <div class="result-item" (click)="onResultItemClick(search)">
              <!--<div class="result-icon">
              <mat-icon>search</mat-icon>
            </div>-->
            <div class="result-content">
              <div class="result-title" [innerHTML]="highlightSearchText(search.item, searchInput)"></div>
              @if (search.module) {
                <div class="result-subtitle">
                  &nbsp;&nbsp;in <span class="modelname">{{ search.module }}</span>
                </div>
              }
            </div>
          </div>
        }
      </div>
      <!-- No Results -->
      @if (!searchResults.length) {
        <div class="no-results">
          <div class="no-results-text">
            No results found for "{{ searchInput }}"
          </div>
        </div>
      }
    </div>
  }
  <!-- Recent Searches -->
  @if (!isSearching && searchInput.length < 3 && recentSearches?.length > 0) {
    <div class="results-section">
      <div class="results-header">
        <span class="results-title">Recent Searches</span>
      </div>
      <div class="results-list">
        @for (search of recentSearches; track search) {
          <div class="result-item" (click)="selectRecentSearch(search)">
            <div class="result-icon">
              <mat-icon>history</mat-icon>
            </div>
            <div class="result-content">
              <div class="result-title">{{ search.item }}</div>
              @if (search.module) {
                <div class="result-subtitle">
                  in {{ search.module }}
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
</div>
<!-- Footer -->
@if (searchInput.length >= 3) {
  <div class="search-modal-footer">
    <a [routerLink]="['/search', { key: searchInput }]" class="see-all-results" (click)="closeSearch()">
      See all results
    </a>
  </div>
}
</div>
</div>
}
</div>
</div>